import { Routes } from '@angular/router';
import { CompanyDashboard } from './company-dashboard/company-dashboard';
import { CompanyPackagesDashboard } from './company-packages-dashboard/company-packages-dashboard';
import { CompanyPackagesPage } from './company-packages-page/company-packages-page';
import { CompanyAppointmentsPage } from './company-appointments-page/company-appointments-page';
import { CompanySettings } from './company-settings/company-settings';
import { NotificationsComponent } from '../../infrastructure/shared/components/notifications/notifications';
import { ClientAppointmentForm } from '../../infrastructure/shared/components/client-appointment-form/client-appointment-form';
import { ClientAppointmentsCalendar } from '../../infrastructure/shared/components/client-appointments-calendar/client-appointments-calendar';

export const companyRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        component: CompanyDashboard,
      },
      {
        path: 'packages',
        component: CompanyPackagesDashboard,
      },
      {
        path: 'packages/offer',
        component: CompanyPackagesPage,
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
      },
      {
        path: 'appointments/create',
        component: ClientAppointmentForm,
        data: { fullWidth: true },
      },
      {
        path: 'appointments',
        component: CompanyAppointmentsPage,
      },
      {
        path: 'calendar',
        component: ClientAppointmentsCalendar,
      },
      {
        path: 'settings',
        component: CompanySettings,
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
